// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"0861365de8c02ee8","255":"0dffb57325612553","704":"0dffb57325612553","931":"0dffb57325612553"}[chunkId] + ".css";
};